import { render, staticRenderFns } from "./searchStuMsg.vue?vue&type=template&id=55ddbcea&scoped=true&"
import script from "./searchStuMsg.vue?vue&type=script&lang=js&"
export * from "./searchStuMsg.vue?vue&type=script&lang=js&"
import style0 from "./searchStuMsg.vue?vue&type=style&index=0&id=55ddbcea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddbcea",
  null
  
)

export default component.exports